




import Class from './c-content-chart-gantt-view';
export default Class;
